<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!--Chart content-->
  <div class="row common-page-contentwrap">
    <div class="col-md-12">
      <div [hidden]="pgLoad">
        <div class="adjust loader-container">
          <div class="loader2"></div>
        </div>
      </div>
      <!-- farm user tabs -->
      <!-- <div [hidden]="!pgLoad" class="row farmuserHeader">
        <div class="metricsList">
          <div class="panel panel-default framuserheaders">
            <div class="panel-body">
              <div class="btn-group btn-group-md col-xs-12 col-md-6">
                <button class="btn btn-primary framsbtn" type="button">Farms</button>
                <button class="btn btn-primary userbtn" type="button">User</button>
              </div>
              <div class="col-xs-12 col-md-6 business_name">
                <h4>{{loginUserBusinessName}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- farm user tabs End -->
      <!-- breadcrumb -->
      <div [hidden]="!pgLoad" class="row">
        <div class="col-md-12">
          <div class="page-breadcrumb">
            <ul class="page-breadcrumb__trail">
                <li><a>Metrics</a></li>
                <li><a>Farm</a></li>
                <li><a>Sampling</a></li>
              </ul>
            <div class="page-breadcrumb__icons">
              <a routerLink="/home" *ngIf="loginUserBusinessCategory != 'Provider'"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
              <a routerLink="/home/dashboard" *ngIf="loginUserBusinessCategory == 'Provider'"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>        
            </div>
          </div>
        </div>
      </div>
      <!-- breadcrumb End -->
      <!-- Pods grid -->
      <div class="block" [hidden]="!pgLoad">
        <div class="screen_heading_div">
          <span>Sampling</span>
        </div>
        <div class="metrics-cards_container row">
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong>  {{charttitle}}</strong></h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="abwgraphselection('doughnut')"
                               [ngClass]="abwType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="abwgraphselection('bar')"
                               [ngClass]="abwType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#activeModal" width="20px"
                               height="17px"
                               (click)="getAllAbwLocation()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                      <!-- <li><img height="17px" src="../../../../../../assets/img/metrics_icons/list.svg" width="20px"/></li> -->
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="canvasarea">
                      <canvas id="abwmyChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              <!--list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <p class="panel panel-default x_chart_panel nodata"
                   *ngIf="abwDetailsList && abwDetailsList.length == 0"> No data found</p>
                <div class="panel panel-default" *ngIf="abwDetailsList && abwDetailsList.length > 0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchBusinessABW()" [(ngModel)]="abwsearch"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th *ngIf="loginUserBusinessCategory != 'Farm'">Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>ABW</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loader2 loaderstyle"></div>
                        </div>
                      </div>
                      <tr class="searchfunabw" *ngFor="let list of abwDetailsList">
                        <td *ngIf="loginUserBusinessCategory != 'Farm'">{{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}</td>
                        <td>{{list && list.name}}</td>
                        <td>{{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}</td>
                        <td>{{(list && list.abw == null) ? 'UA' : (list && list.abw.toFixed(2))}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!--count-->
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong>  {{inActivecharttitle}}</strong></h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="countgraphselection('doughnut')"
                               [ngClass]="countType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="countgraphselection('bar')"
                               [ngClass]="countType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#inActiveModal" height="17px"
                               width="20px"
                               (click)="getAllCountsLocation()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                      <!-- <li><img height="17px" src="../../../../../../assets/img/metrics_icons/list.svg" width="20px"/></li> -->
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="countcanvasarea">
                      <canvas id="countmyChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              <!--list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <p class="panel panel-default x_chart_panel nodata"
                   *ngIf="countDetailsList && countDetailsList.length == 0"> No data found</p>
                <div class="panel panel-default" *ngIf="countDetailsList && countDetailsList.length > 0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchBusinessCount()" [(ngModel)]="countsearch"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th *ngIf="loginUserBusinessCategory != 'Farm'">Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>Count</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loader2 loaderstyle"></div>
                        </div>
                      </div>
                      <tr class="searchfuncount" *ngFor="let list of countDetailsList">
                        <td *ngIf="loginUserBusinessCategory != 'Farm'">{{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}</td>
                        <td>{{list && list.name}}</td>
                        <td>{{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}</td>
                        <td>{{(list && list.count == null) ? 'UA' : (list && list.count.toFixed(2))}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--adg -->
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong>  {{pondSizecharttitle}}</strong></h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="adggraphselection('doughnut')"
                               [ngClass]="adgType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="adggraphselection('bar')"
                               [ngClass]="adgType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#pondSizeModal" height="17px"
                               width="20px"
                               (click)="getAllAdgPondLocation()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                      <!-- <li><img height="17px" src="../../../../../../assets/img/metrics_icons/list.svg" width="20px"/></li> -->
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="adgcanvasarea">
                      <canvas id="adgmyChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              <!--list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <p class="panel panel-default x_chart_panel nodata"
                   *ngIf="adgDetailsList && adgDetailsList.length == 0"> No data found</p>
                <div class="panel panel-default" *ngIf="adgDetailsList && adgDetailsList.length > 0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchBusinessadg()" [(ngModel)]="adgsearch"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th *ngIf="loginUserBusinessCategory != 'Farm'">Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>ADG</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loader2 loaderstyle"></div>
                        </div>
                      </div>
                      <tr class="searchfunadg" *ngFor="let list of adgDetailsList">
                        <td *ngIf="loginUserBusinessCategory != 'Farm'">{{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}</td>
                        <td>{{list && list.name}}</td>
                        <td>{{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}</td>
                        <td>{{(list && list.adg == null) ? 'UA' : (list && list.adg.toFixed(2))}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End Ponds grid -->
        </div>
      </div>
      <!-- ABW Location view -->
      <div class="modal fade" id="activeModal" role="dialog" *ngIf="abwLocations && abwLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal"  title="Close Popup">&times;</button>
              <h4 class="modal-title location_heading">Ponds by ABW Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of abwLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-9 doc_villagename">
                    <!--<span>{{village.district}},</span>&nbsp;--><span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-3 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <!--<div class="col-xs-12">-->
                  <div class="row">
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">UA</h3>
                      <h3 class="pull-right doc_count">{{village.undefinedCount}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">DOC <span>&#8804;</span> 12g</h3>
                      <h3 class="pull-right doc_count">{{village.less_than_12}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">13g - 15g</h3>
                      <h3 class="pull-right doc_count">{{village.twelve_fifteen_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">16g - 17g</h3>
                      <h3 class="pull-right doc_count">{{village.fifteen_seventeen_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">18g - 20g</h3>
                      <h3 class="pull-right doc_count">{{village.seventeen_twenty_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">21g - 25g</h3>
                      <h3 class="pull-right doc_count">{{village.twenty_twentyfive_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">> 25g</h3>
                      <h3 class="pull-right doc_count">{{village.greater_than_twentyFive}}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>

        </div>
      </div>
      <!-- End ABW Location view -->
      <!-- ponds by count Location view -->
      <div class="modal fade" id="inActiveModal" role="dialog"
           *ngIf="pondsByCountLocations && pondsByCountLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal"  title="Close Popup">&times;</button>
              <h4 class="modal-title location_heading">Ponds by Count Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of pondsByCountLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-9 doc_villagename">
                    <!--<span>{{village.district}},</span>&nbsp;&nbsp;--><span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-3 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">UA</h3>
                      <h3 class="pull-right doc_count">{{village.undefinedCount}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">> 100</h3>
                      <h3 class="pull-right doc_count">{{village.greater_than_hundred}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">91 - 100</h3>
                      <h3 class="pull-right doc_count">{{village.ninety_hundred_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">71 - 90</h3>
                      <h3 class="pull-right doc_count">{{village.seventy_ninety_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">51 - 70</h3>
                      <h3 class="pull-right doc_count">{{village.fifty_seventy_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">31 - 50</h3>
                      <h3 class="pull-right doc_count">{{village.thirty_fifty_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading"><span>&#8804;</span> 30</h3>
                      <h3 class="pull-right doc_count">{{village.less_than_thirty}}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- End pond by count Location view -->
      <!-- ponds by ADG Location view -->
      <div class="modal fade" id="pondSizeModal" role="dialog" *ngIf="adgLocations && adgLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal"  title="Close Popup">&times;</button>
              <h4 class="modal-title location_heading">Ponds by ADG Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of adgLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-9 doc_villagename">
                    <!--<span>{{village.district}},</span>&nbsp;--><span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-3 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">UA</h3>
                      <h3 class="pull-right doc_count">{{village.undefinedCount}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading"><span>&#8804;</span> 0.2</h3>
                      <h3 class="pull-right doc_count">{{village.zero_pointTwo_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">0.3 - 0.4</h3>
                      <h3 class="pull-right doc_count">{{village.pointTwo_pointFour_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">0.5 - 0.6</h3>
                      <h3 class="pull-right doc_count">{{village.pointFour_pointSix_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">0.7 - 0.8</h3>
                      <h3 class="pull-right doc_count">{{village.pointSix_pointEight_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">0.9 - 1.0</h3>
                      <h3 class="pull-right doc_count">{{village.pointEight_one_count}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">> 1.0</h3>
                      <h3 class="pull-right doc_count">{{village.greater1}}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- End pond by ADG Location view -->
    </div>
  </div>
</div>
